import React from 'react';
import { Icon } from './Icon.js';
export const IconRadioCheckedFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m6,0C2.691,0,0,2.691,0,6s2.691,6,6,6,6-2.691,6-6S9.309,0,6,0Zm0,9c-1.654,0-3-1.346-3-3s1.346-3,3-3,3,1.346,3,3-1.346,3-3,3Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconRadioCheckedFill12.js.map